if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();

      this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      this.sellingPLanChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.sellingPlanChange, this.onSellingPlanChange.bind(this));
    }
    
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.bar = this.querySelector('.sticky-atc__bar');
      this.image = this.querySelector('.sticky-atc__image');
      this.swatches = this.querySelectorAll('.sticky-atc__swatch');
      this.buyMultipleText = this.querySelector('.sticky-atc__buy-multiple');
      this.sellingPlanText = this.querySelector('.sticky-atc__selling-plan');
      this.changeOptionButton = this.querySelector('.sticky-atc__change-option');

      this.ProductInfo = document.querySelector(`#ProductInfo-${this.dataset.section}`);
      this.ProductSubmitButton = document.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
      this.KlaviyoPopupOpener = document.querySelector(`#KlaviyoPopupOpener-${this.dataset.section}`);
      this.TryNowCta = document.querySelector('.trynow-cta-wrap');

      this.hasProductOptions = !!this.ProductInfo.querySelector('variant-selects, concealer-variant, set-amount-quantity-selector, selling-plans');

      if (this.hasProductOptions) {
        this.changeOptionButton.classList.remove('sticky-atc__change-option--hidden');
      }

      if (this.swatches.length > 0) {
        this.changeOptionButton.innerHTML = 'Change shade';
      }
      
      if (
        (this.ProductInfo && this.ProductSubmitButton) ||
        (this.ProductInfo && this.KlaviyoPopupOpener) ||
        (this.ProductInfo && this.TryNowCta)
      ) {
        this.initObserver();
        this._listenersAdded = true;
        this.addEventListener('click', this.handleVariantSelectorClick.bind(this));
        window.addEventListener('set-quantity:change', this.onSetQuantityChange.bind(this));
      }

      document.addEventListener('trynow:ready', () => {
        this.TryNowCta = document.querySelector('.trynow-cta-wrap');
        if (!this.ProductInfo || !this.TryNowCta) return;
        if (this.observer) this.observer.disconnect();
        this.initObserver();
        if (!this._listenersAdded) {
          this._listenersAdded = true;
          this.addEventListener('click', this.handleVariantSelectorClick.bind(this));
          window.addEventListener('set-quantity:change', this.onSetQuantityChange.bind(this));
        }
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.variantIdChangedUnsubscriber) {
        this.variantIdChangedUnsubscriber();
      }
      if (this.sellingPLanChangedUnsubscriber) {
        this.sellingPLanChangedUnsubscriber();
      }
    }

    initObserver() {
      this.observer = new IntersectionObserver(
        ([{ isIntersecting: visible }]) => {
          this.toggleVisibility(visible);
        }
      );
    
      if (this.TryNowCta) {
        this.observer.observe(this.TryNowCta);
      } else if (this.ProductSubmitButton) {
        this.observer.observe(this.ProductSubmitButton);
      } else if (this.KlaviyoPopupOpener) {
        this.observer.observe(this.KlaviyoPopupOpener);
      }
    }

    toggleVisibility(infoVisible) {
      let showATC = !infoVisible;

      if (this.TryNowCta) {
        const rect = this.TryNowCta.getBoundingClientRect();
        showATC = !infoVisible && (window.scrollY > (rect.y + window.scrollY));
      } else if (this.ProductSubmitButton) {
        const rect = this.ProductSubmitButton.getBoundingClientRect();
        showATC = !infoVisible && (window.scrollY > (rect.y + window.scrollY));
      } else if (this.KlaviyoPopupOpener) {
        const rect = this.KlaviyoPopupOpener.getBoundingClientRect();
        showATC = !infoVisible && (window.scrollY > (rect.y + window.scrollY));
      }

      this.setAttribute('aria-hidden', !showATC);

      let stickyBarHeight = 0;
      if (showATC) {
        stickyBarHeight = this.bar.offsetHeight;
      }
      document.documentElement.style.setProperty('--sticky-bar-height', `${stickyBarHeight}px`);
    }

    onVariantChange(evt) {
      this.swatches.forEach(swatch => {
        swatch.classList.toggle(
          'sticky-atc__swatch--selected',
          (evt.data.variant.id).toString() === swatch.dataset.variantId
        );
      });
    }

    onSellingPlanChange(evt) {
      if (evt.data.sectionId !== this.sectionId) return;
      this.classList.toggle(
        'sticky-atc--selling-plan',
        evt.data.sellingPlan.name !== ''
      );
      this.classList.toggle(
        'sticky-atc--buy-multiple',
        evt.data.sellingPlan.name === ''
      );
      if (this.sellingPlanText) {
        this.sellingPlanText.innerHTML = evt.data.sellingPlan.name;
      }
    }

    onSetQuantityChange(evt) {
      const buyMultiple = evt.detail.target.value !== '1';
      const quantity = evt.detail.target.value;
      const quantityFree = evt.detail.target.dataset.quantityFree;
      const amountImage = evt.detail.target.dataset.amountImage;
      this.classList.add('sticky-atc--hide-swatches');
      this.classList.remove('sticky-atc--selling-plan');

      if (this.image && amountImage) {
        this.image.src = amountImage;
      }

      if (this.buyMultipleText) {
        this.classList.add('sticky-atc--hide-swatches');
        this.classList.remove('sticky-atc--buy-multiple');
        this.buyMultipleText.innerHTML = null;
      }
      this.changeOptionButton.innerHTML = 'Select options';

      if (buyMultiple) {
        this.changeOptionButton.innerHTML = 'Select options';

        if (this.buyMultipleText) {
          this.classList.add('sticky-atc--buy-multiple');
          if (quantityFree && quantityFree > 0) {
            this.buyMultipleText.innerHTML = `Buy ${quantity - quantityFree} + Get ${quantityFree}`;
          } else {
            this.buyMultipleText.innerHTML = `Buy ${quantity}`;
          }
        }
      } else {
        if (this.swatches.length > 0) {
          this.classList.remove('sticky-atc--hide-swatches');
          this.changeOptionButton.innerHTML = 'Change shade';
        } else if (this.buyMultipleText) {
          this.classList.add('sticky-atc--buy-multiple');
          this.buyMultipleText.innerHTML = `Buy ${quantity}`;
        }
      }
    }

    handleVariantSelectorClick(evt) {
      if (evt.target.closest('.sticky-atc__change-option')) {
        evt.preventDefault();
        let rect = {
          y: 0
        };

        if (this.TryNowCta) {
          rect = this.TryNowCta.getBoundingClientRect();
        } else if (this.ProductSubmitButton) {
          rect = this.ProductSubmitButton.getBoundingClientRect();
        } else if (this.KlaviyoPopupOpener) {
          rect = this.KlaviyoPopupOpener.getBoundingClientRect();
        } else {
          rect = this.ProductInfo.getBoundingClientRect();
        }

        window.scroll({
          top: (rect.y + window.scrollY) - (window.innerHeight / 4 * 3),
          behavior: "smooth",
        });
      }
    }
  }

  customElements.define("sticky-atc", StickyATC);
}